import { Component, Inject, Input, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { BehaviorSubject, Subscription } from "rxjs";
import { SocialService } from "src/app/services/social.service";
import { AuthService } from "@core/auth.service";
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from "@angular/material/expansion";
import { AsyncPipe, UpperCasePipe } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
@Component({
    selector: "app-social-benefits",
    templateUrl: "./social-benefits.component.html",
    styleUrls: ["./social-benefits.component.scss"],
    standalone: true,
    imports: [
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        AsyncPipe,
        UpperCasePipe,
        TranslatePipe,
    ],
})
export class SocialBenefitsComponent implements OnDestroy{
  panelOpenState = false;
  @Input() currentTab: number;
  cardData$ = new BehaviorSubject(null);
  cards = null;
  allCards: Data;
  isCurrentCard = true;
  public currentVIPStatus: string;
  public languageCode: string;
  private languageSubscription: Subscription;
  // Aman : last modified with vip status data binding on 15th Nov 2022
  constructor(
    private matDialogRef: MatDialogRef<SocialBenefitsComponent>,
    private socialService: SocialService,
    @Inject(MAT_DIALOG_DATA) data : Data,
    private authService: AuthService,
  ) {
    // This variable contains the current VIP status Level data
    this.currentVIPStatus = data?.vipStatusLevel?.level;
    // This method has been used for get benefits data from firebase.
    this.socialService.getVIPbenefits(data?.vipStatusLevel?.benefits).then((res: Data) => {
        try {
          this.cardData$.next(res);
          this.allCards = res;
        } catch (err) {
          // handle error
          throw new Error(err);
        }
      })
      .catch((error) => {
        return error;
      });
    // This method is used to translate language
    // Subscribe to the authService's selectedlanguage$ Observable
    this.languageSubscription = this.authService?.selectedlanguage$?.subscribe(
      (language: string) => {
        this.languageCode = language;
      },
      (err) => {
        console.error(err);
      }
    );
  }
  ngOnDestroy() : void {
    // Unsubscribe when the component is destroyed to avoid memory leaks
    if (this.languageSubscription) {
      // Unsubscribe from the language subscription
      this.languageSubscription.unsubscribe();
    }
  }

  socialBenefitDialog(isCurrent: boolean) {
    isCurrent = !isCurrent;
    this.isCurrentCard = isCurrent;
    if (isCurrent) {
      this.cardData$.next(this.allCards);
    } else {
      this.cardData$.next(this.allCards?.nextData);
    }
  }

  close() {
    this.matDialogRef.close();
  }
}
